<!--
  inputmode="none" is used to prevent opening virtual keyboard on focus

  Mainly used for other ScreenReaders like TalkBack where it marks input element as disabled when using readonly.
-->
<ion-input
  aria-haspopup="dialog"
  aria-live="assertive"
  (ionFocus)="setOpen(true)"
  (keypress)="$event.preventDefault(); $event.stopImmediatePropagation()"
  placeholder="Enter a time"
  [attr.id]="instanceId"
  [attr.aria-describedby]="ariaDescribedBy"
  [attr.aria-label]="ariaLabel"
  [attr.aria-labelledby]="ariaLabelledBy"
  value="{{ val ? (val | date: timeDisplayFormat) : '' }}"
  [readonly]="showToggleButton"
  inputmode="none"
/>

<mable-button
  #timePickerButton
  *ngIf="showToggleButton"
  aria-haspopup="dialog"
  ariaLabel="Open time picker"
  category="icon-only"
  icon="time"
  color="grey-500"
  (onClick)="setOpen(true, true)"
/>

<ion-modal
  [attr.data-testid]="modalDataTestId"
  [attr.trigger]="instanceId"
  [isOpen]="isModalOpen"
  (didDismiss)="setOpen(false)"
  [initialBreakpoint]="0.5"
  [breakpoints]="[0.5]"
  [backdropDismiss]="false"
  [keepContentsMounted]="true"
>
  <ng-template>
    <ion-datetime
      #mabletime
      presentation="time"
      [formControl]="localValueControl"
      [minuteValues]="minuteValues"
    >
      <ion-buttons slot="buttons">
        <ion-button
          color="primary"
          (click)="cancel()"
          >Cancel</ion-button
        >
        <ion-button
          color="primary"
          (click)="select(mabletime.value)"
          >Done</ion-button
        >
      </ion-buttons>
    </ion-datetime>
  </ng-template>
</ion-modal>
